import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/es/reduxForm';
import LoginAU from 'components/Credit24/SelfService/LoginAU';
import validateAU from 'utils/validation/au/validateAuthentication';
import { login, toggleRecoveryPasswordScreen } from 'actions/authentication';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  toggleRecoveryPasswordScreenHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

class LoginAUContainer extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { authentication, router } = this.props;
    if (!authentication.isAuthenticated && nextProps.authentication.isAuthenticated) {
      const { location, replace } = router;
      const { from } = location.state || { from: { pathname: '/' } };
      // if (nextProps.authentication.isChangingPassword) {
      //   from = { pathname: '/change-password' };
      // }
      replace(from);
    }
  }

  onSubmit(credentials) {
    this.props.login(credentials.username, credentials.login_pass);
  }

  render() {
    const { authentication, toggleRecoveryPasswordScreenHandler } = this.props;
    return (
      <form className="homepage homepage--type-login" onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <LoginAU
          authentication={authentication}
          toggleRecoveryPasswordScreen={toggleRecoveryPasswordScreenHandler}
        />
      </form>
    );
  }
}

LoginAUContainer.propTypes = propTypes;

export default reduxForm({
  form: 'authentication-form',
  validate: validateAU,
  onSubmitFail: (errors, dispatch, submitErrors) => {
    if (DEBUG) {
      console.warn('form submit fail', errors, submitErrors);
    }
  },
})(connect(
  (state) => ({
    authentication: state.authentication,
  }),
  {
    toggleRecoveryPasswordScreenHandler: toggleRecoveryPasswordScreen,
    login,
  }
)(LoginAUContainer));
